/**
 * @copyright Microsoft Corporation. All rights reserved.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var flightsSplitter = ';';
var keyValueFlightSplitter = ':';
export function parseFlights(serializedFlights) {
    var e_1, _a;
    if (!serializedFlights) {
        return new WorkflowFlights([], new Set(), new Map());
    }
    var flights = serializedFlights.split(flightsSplitter);
    var normalizedFlights = new Set();
    var flightsMap = new Map();
    try {
        for (var flights_1 = __values(flights), flights_1_1 = flights_1.next(); !flights_1_1.done; flights_1_1 = flights_1.next()) {
            var flight = flights_1_1.value;
            var trimmedFlight = flight.trim();
            if (trimmedFlight === '') {
                continue;
            }
            normalizedFlights.add(WorkflowFlights.normalizeName(trimmedFlight));
            var _b = __read(trimmedFlight.split(keyValueFlightSplitter), 2), flightName = _b[0], flightValue = _b[1];
            var normalizedFlightName = WorkflowFlights.normalizeName(flightName);
            if (normalizedFlightName) {
                flightsMap.set(normalizedFlightName, flightValue);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (flights_1_1 && !flights_1_1.done && (_a = flights_1.return)) _a.call(flights_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return new WorkflowFlights(flights, normalizedFlights, flightsMap);
}
var WorkflowFlights = /** @class */ (function () {
    function WorkflowFlights(originalFlights, normalizedFlights, keyValueFlightsMap) {
        this.originalFlights = originalFlights;
        this.normalizedFlights = normalizedFlights;
        this.keyValueFlightsMap = keyValueFlightsMap;
    }
    WorkflowFlights.normalizeName = function (name) {
        return name === null || name === void 0 ? void 0 : name.toLowerCase();
    };
    WorkflowFlights.prototype.hasFlight = function (flight) {
        var normalizedName = WorkflowFlights.normalizeName(flight);
        var wholeFlightMatched = this.normalizedFlights.has(normalizedName);
        var flightNameMatched = this.keyValueFlightsMap.has(normalizedName);
        return wholeFlightMatched || flightNameMatched;
    };
    WorkflowFlights.prototype.getBooleanValue = function (flightName, fallbackValue) {
        var _a;
        var normalizedValue = (_a = this.getStringValue(flightName)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        switch (normalizedValue) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return fallbackValue;
        }
    };
    WorkflowFlights.prototype.getIntValue = function (flightName, fallbackValue) {
        var value = this.getStringValue(flightName);
        var parsed = Number.parseInt(value, 10);
        if (Number.isNaN(parsed)) {
            return fallbackValue;
        }
        return parsed;
    };
    WorkflowFlights.prototype.getStringValue = function (flightName, fallbackValue) {
        var _a;
        return (_a = this.keyValueFlightsMap.get(WorkflowFlights.normalizeName(flightName))) !== null && _a !== void 0 ? _a : fallbackValue;
    };
    WorkflowFlights.prototype.getAll = function () {
        return this.originalFlights;
    };
    return WorkflowFlights;
}());
export { WorkflowFlights };
//# sourceMappingURL=workflow-flights.js.map